export const urlValidator = (value) =>
  !value || value.includes('http://') || value.includes('https://') ? undefined : 'url must be of the form http(s)://'

export const fullNameValidator = (_, value) => {
  if (!value.trim().includes(' ')) {
    return Promise.reject(new Error('Includes space'))
  }
  return Promise.resolve()
}
